const tabsId = Object.freeze({
  PerfilProponente: 0,
  DetallePropuesta: 1,
  DocumentosPropuesta: 2,
  Evaluation: 3,
  Contratacion: 4,
  SeparationFondos: 5,
  DocumentosContrato: 6,
  Bitácora: 7,
  Historial: 8,
});

export default tabsId;
